const $ = require('jquery');
require('popper.js');
require('bootstrap');

const constants = require('./data/constants');
const Localization = require('./utils/Localization');
const Ui = require('./utils/Ui');
const Preloader = require('./utils/Preloader');
const Storage = require('./utils/Storage');
const Api = require('./Api');
const ApiV2 = require('./ApiV2');


const preloader = new Preloader();
preloader.showCursorPreloader();

const storage = new Storage();
const localization = new Localization();
const apiV2 = new ApiV2(localization);
const apiLegacy = new Api(localization);

let api = apiV2;

class Login {
  constructor() {
    this.formLoginLegacy = $('#formLoginLegacy');
    this.formLogin = $('#formLogin');
    this.formReset = $('#formReset');
    this.demoCredentials = {
      company: 'infoware',
      username: 'demo',
      password: 'demodemo',
    };
    $('#fullResetForm').hide();
  }

  addListeners() {
    $(this.formLoginLegacy).on('submit', (event) => {
      event.preventDefault();
      this.parseLoginFormLegacy();
    });

    $(this.formLogin).on('submit', (event) => {
      event.preventDefault();
      this.parseLoginForm();
    });

    this.formReset.on('submit', (event) => {
      event.preventDefault();
      this.parseResetForm();
    });

    $(document).on('keypress', (event) => {
      if (event.which === 13) {
        event.preventDefault();

        storage.getOption('appMode')
          .then((result) => {
            switch(result) {
              case constants.APP_MODE_NORMAL:
                this.formLogin.trigger('submit');
                break;
              default:
                this.formLoginLegacy.trigger('submit')
            }
          });
      }
    });

    $('#btnDemoLegacy').on('click', () => {
      this.initDemo();
    });

    $('#btnDemo').on('click', () => {
      this.initDemo();
    });

    $('#legacyLoginLink').on('click', () => {
      storage.putOption('appMode', constants.APP_MODE_LEGACY)
        .then(() => {
          $('#login').hide();
          $('#legacyLogin').show();
          api = apiLegacy;
        });
    });

    $('#loginLink').on('click', () => {
      storage.putOption('appMode', constants.APP_MODE_NORMAL)
        .then(() => {
          $('#login').show();
          $('#legacyLogin').hide();
          api = apiV2;
        });
    });

    $('#passwordResetLink').on('click', (event) => {
      event.preventDefault();

      $('#formLoginContainer').hide();
      $('#legacyLogin').hide();
      $('#formResetContainer').show();
    });

    $('#goToLoginForm').on('click', (event) => {
      event.preventDefault();
      $('#formLoginContainer').show();
      $('#formResetContainer').hide();
    });
  }

  parseLoginFormLegacy() {
    preloader.showCursorPreloader();

    const form = document.getElementById('formLoginLegacy');

    if (!form.checkValidity()) {
      preloader.hideCursorPreloader();
      this.formLoginLegacy.addClass('was-validated');
      return;
    }

    const username = this.formLoginLegacy.find('#usernameLegacy').val();
    const company = this.formLoginLegacy.find('#companyLegacy').val();
    const password = this.formLoginLegacy.find('#passwordLegacy').val();

    Login.doLoginLegacy(company, username, password);
  }

  parseLoginForm() {
    preloader.showCursorPreloader();

    const form = document.getElementById('formLogin');

    const username = this.formLogin.find('#username').val();
    const password = this.formLogin.find('#password').val();
    const rememberMe = this.formLogin.find('#cbRememberMe').is(':checked');

    Login.doLogin(username, password, rememberMe);
  }

  parseResetForm() {
    preloader.showCursorPreloader();

    const form = document.getElementById('formReset');

    if(!form.checkValidity()) {
      preloader.hideCursorPreloader();
      this.formReset.addClass('was-validated');
      return;
    }

    const email = this.formReset.find('#email').val();
    const callbackUrl = "https://" + window.location.host + "/112/reset.html";

    api.initPasswordReset(email, callbackUrl)
      .then(() => {
        Ui.showModalSuccess(localization.translate('login-page.reset-successful'))
        preloader.hideCursorPreloader();
      })
      .catch((error) => {
        console.error(error);

        let msg = error.responseJSON.title;

        const translationKey = 'login-page.' + error.responseJSON.message;

        if(localization.translationExists(translationKey)) {
          msg = localization.translate(translationKey);

          if(error.responseJSON.details) {
            msg += result.responseJSON.details;
          }

          Ui.showModalError(msg);
        } else {
          Ui.showModalError(localization.translate("errors.could-not-login"));
        }
        preloader.hideCursorPreloader();
      });
  }

  initDemo() {
    preloader.showCursorPreloader();

    storage.getOption('appMode')
      .then((result) => {
        switch(result) {
          case constants.APP_MODE_NORMAL:

            const name = this.demoCredentials.username;
            const pw = this.demoCredentials.password;
            const rememberMe = false;
            Login.doLogin(name, pw, rememberMe);
            break;
          default:
            const { company, username, password } = this.demoCredentials;
            Login.doLoginLegacy(company, username, password);
            break;
        }
      });
  }

  static doLogin(username, password, rememberMe) {
    api.login(username, password, rememberMe)
      .then((user) => {

        Promise.all([api.getUserData(user.sessionId)])
          .then(results => {

            const userData = results[0];

            const promises = [];
            promises.push(storage.putOption('user', user));

            api.getUserOptions(user.sessionId)
              .then((result) => {

                const userOptions = result;

                let permission;
                if(userOptions.some(option => option.type === "permission")) {
                  permission = JSON.parse(userOptions.find(option => option.type === "permission").value);
                }

                if(permission && permission.active) {
                  promises.push(storage.putOption('permissions', permission));
                } else {
                  promises.push(storage.deleteOption('permissions'));
                }
              })
              .catch(error => {
                promises.push(storage.deleteOption('permissions'));
                console.error(error);
              })
              .finally(() => {
                user.company = userData.company.name;
                let provider = "tomtom";

                if(userData.company.attributesAdmin && userData.company.attributesAdmin.detourLimit) {
                  let detourLimit = userData.company.attributesAdmin.detourLimit;
                  storage.putOption(constants.DETOUR_LIMIT, detourLimit);
                } else {
                  storage.deleteOption(constants.DETOUR_LIMIT);
                }

                if(userData && userData.company.provider) {
                  provider = userData.company.provider.name.toLocaleLowerCase();
                }

                if(constants.FWW_ACCOUNTS.includes(user.username) || constants.FWW_ACCOUNTS.includes(user.company)) {
                  api.setDefaultServer(constants.PROVIDER_FWW);
                  promises.push(storage.putOption(constants.PROVIDER_STORAGE_KEY, constants.PROVIDER_FWW));
                } else {
                  api.setDefaultServer(provider);
                  promises.push(storage.putOption(constants.PROVIDER_STORAGE_KEY, provider));
                }

                Promise.all(promises)
                  .then(() => {
                    window.location = 'index.html';
                  });
              })
          })
          .catch(err => {
            preloader.hideCursorPreloader();
            console.error(err)
          });
      })
      .catch((error) => {
        console.error(error);

        let msg = error.responseJSON.title;

        const translationKey = 'login-page.' + error.responseJSON.message;

        if(localization.translationExists(translationKey)) {
          msg = localization.translate(translationKey);

          if(error.responseJSON.details) {
            msg += result.responseJSON.details;
          }

          Ui.showModalError(msg);
        } else {
          Ui.showModalError(localization.translate("errors.could-not-login"));
        }

        preloader.hideCursorPreloader();
      });
  }

  static doLoginLegacy(company, username, password) {

    api.login(company, username, password, constants.PROVIDER_TOMTOM)
        .then((response) => {
          api.setDefaultServer(constants.PROVIDER_TOMTOM);

          Promise.all([storage.putOption('user', response), storage.putOption(constants.PROVIDER_STORAGE_KEY, constants.PROVIDER_TOMTOM)])
              .then(() => {
                window.location = 'index.html';
              })
              .catch((error) => {
                console.error(error);
                Ui.showModalError(localization.translate("errors.could-not-login"));
              });
          preloader.hideCursorPreloader();
        })
        .catch((error) => {
          if([3004, 3005, 3006].indexOf(parseInt(error.code)) !== -1) {
            this.doLoginLegacyHere(company, username, password);
          } else {
            Ui.showModalError(error.message);
            preloader.hideCursorPreloader();
          }
        });
  }

  static doLoginLegacyHere(company, username, password) {
    api.login(company, username, password, constants.PROVIDER_HERE)
        .then((response) => {
          api.setDefaultServer(constants.PROVIDER_HERE);
            Promise.all([storage.putOption('user', response), storage.putOption(constants.PROVIDER_STORAGE_KEY, constants.PROVIDER_HERE)])
              .then(() => {
                window.location = 'index.html';
              })
              .catch((error) => {
                console.error(error);
                Ui.showModalError('Could not log you in due to an internal server error. Please contact the owner.');
              });
          preloader.hideCursorPreloader();
        })
        .catch((error) => {
            Ui.showModalError(error.message);
            preloader.hideCursorPreloader();
        });
  }
}

const login = new Login();

Promise.all([localization.init(), storage.init()])
  .then(() => {
    preloader.hideCursorPreloader();

    $(() => {
      login.addListeners();
      storage.putOption('appMode', constants.APP_MODE_NORMAL);
    });
  })
  .catch((error) => {
    Ui.showModalError(localization.translate("errors.could-not-init-app", {errorMessage: error.message}));
  });
